namespace TabAurous.Common {
    export interface PartySelectForm {
        PartyId: Serenity.LookupEditor;
    }

    export class PartySelectForm extends Serenity.PrefixedContext {
        static formKey = 'Common.PartySelect';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PartySelectForm.init)  {
                PartySelectForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;

                Q.initFormType(PartySelectForm, [
                    'PartyId', w0
                ]);
            }
        }
    }
}
